import { useState } from 'react';
import { cn } from '@simplywallst/ui-core/next';
import { useCloudflareImage } from '@/hooks/useCloudflareImage';
import { useSummary } from '@/hooks/useCompany';

const CLOUDFLARE_CONFIG = {
  // TODO: Should we have a smaller variant for mobile?
  width: 200,
  height: 42,
  blur: 6,
};

// TODO: For a NoImage display we need a way to tell if there is genuinely no image
// export const NoImage = () => (
//   <div
//     className="pointer-events-none absolute inset-0 bg-gradient-to-tr
//         from-legacy-spacegray to-legacy-noir lg:rounded-b-md"
//   />
// );

export const Image = ({ src, alt }: { src: string; alt: string }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const resizedImage = useCloudflareImage({ ...CLOUDFLARE_CONFIG, src });

  return (
    <div
      className={cn(
        'light:hidden', // The cover treatment is poor on light mode so hiding for now
        'pointer-events-none absolute inset-0 lg:rounded-b-md',
        '[-webkit-mask-image:linear-gradient(rgba(0,0,0,0)_0%,rgba(0,0,0,.15)_25%,rgba(0,0,0,0)_100%)]',
        'md:[-webkit-mask-image:linear-gradient(60deg,rgba(0,0,0,.2)_15%,rgba(0,0,0,0)_100%)]',
        'transition-opacity delay-75 duration-[2s] ease-in-out',
        isLoaded ? 'opacity-100' : 'opacity-0'
      )}
    >
      <img
        src={resizedImage}
        alt={alt}
        className="z-1 size-full object-cover"
        onLoad={() => {
          setIsLoaded(true);
        }}
      />
    </div>
  );
};

export const BlurredBackground = () => {
  const summary = useSummary();

  if (summary.status === 'loading') return;

  if (!summary.coverImage) return;

  return <Image src={summary.coverImage} alt={`${summary.name} logo`} />;
};
